import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";

const themes = (state: RootState) => state.themes;
export const themesSelector = createSelector(themes, (state) => state);
